import { FC, useMemo } from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'processes/auth/model/state';
import { Routes } from 'app/config/routes/consts';

const URGENT_DAYS = 3;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

const PasswordExpiryBanner: FC = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { user } = useAuthStore();

	const daysLeft = useMemo(() => {
		if (!user?.passwordRotateAt) return null;
		const ms = new Date(user.passwordRotateAt).getTime() - Date.now();
		return Math.ceil(ms / MS_PER_DAY);
	}, [user?.passwordRotateAt]);

	if (daysLeft === null || daysLeft > URGENT_DAYS) return null;

	return (
		<Alert
			severity={'error'}
			sx={{ marginBottom: '16px', cursor: 'pointer' }}
			onClick={() => navigate(Routes.personalAccount)}
		>
			{t('password_expiry.banner', { count: daysLeft })}
		</Alert>
	);
};

export default PasswordExpiryBanner;
